import React from "react";
import { graphql, PageProps } from "gatsby";
import Layout from "../components/layout";
import { MDXProvider } from "@mdx-js/react"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { BasePagesQuery } from "./__generated__/BasePagesQuery";

export default function basePages({ data, location }: PageProps<BasePagesQuery, {}>) {
    return (
        <Layout seo={{
            title: data.mdx.frontmatter.title,
            description: data.mdx.frontmatter.description,
            image: data.mdx.frontmatter.image?.publicURL
        }}
        location={location}>
            <div className="large-container">
                <header className="measure pt-20 pb-10 lg:pt-32 lg:pb-12 text-center">
                    <h1 className="display-2 text-color-1">
                        {data.mdx.frontmatter.title}
                    </h1>
                    {data.mdx.frontmatter.description && (
                        <p className="lede mt-8">
                            {data.mdx.frontmatter.description}
                        </p>
                    )}
                    <div className="rule-short mt-12 mx-auto"></div>
                </header>

                <div className="measure post-content pb-24 lg:pb-32">
                    <MDXProvider>
                        <MDXRenderer>{data.mdx.body}</MDXRenderer>
                    </MDXProvider>
                </div>
            </div>
        </Layout>
    );
}


export const query = graphql`
    query BasePagesQuery($slug: String!) {
        mdx(fields: { slug: { eq: $slug } }) {
            body
            frontmatter {
                title
                image {
                    publicURL
                }
                description
            }
        }
    }
`;
